import React, { useEffect } from "react";
import {
    Navigate,
    Route,
    BrowserRouter as Router,
    Routes,
} from "react-router-dom";
import { useRouting } from "JS/React//Hooks/Routes";
import { DownloadsOffline } from "JS/React//Scenes/DownloadsOffline/DownloadsOffline";
import { ContentDetailOffline } from "JS/React/Scenes/DownloadsOffline/ContentDetailOffline";
import { BundleDetailOffline } from "JS/React/Scenes/DownloadsOffline/BundleDetailOffline";
import { BundlePlayerOffline } from "./Scenes/DownloadsOffline/BundlePlayerOffline";
import { Box, Typography } from "@mui/material";
import { isDeviceAllowed } from "JS/Helpers";
import { AttachedSkuOffline } from "./Scenes/DownloadsOffline/AttachSkuOffline";
import { DownloadMenu } from "./Scenes/DownloadsOffline/DownloadMenu";
import { PlaylistListing } from "./Scenes/DownloadsOffline/Playlist";
import { PlaylistDetail } from "./Scenes/DownloadsOffline/Playlist/PlaylistDetail";
import { PlaylistPlayer } from "./Scenes/DownloadsOffline/Playlist/PlaylistPlayer";
import { OfflineCourses } from "./Scenes/DownloadsOffline/Courses";
import { OfflineCourseDetail } from "./Scenes/DownloadsOffline/Courses/OfflineCourseDetail";
import { OfflineDocuments } from "./Scenes/DownloadsOffline/Documents";
import { OfflineDocumentDetail } from "./Scenes/DownloadsOffline/Documents/OfflineDocumentDetail";
import { OfflineCourseStep } from "./Scenes/DownloadsOffline/Courses/Steps/OfflineCourseStep";
import { useGlobalMedia } from "./Hooks/Media";
import { Helmet } from "react-helmet-async";
import { useMiniPlayer } from "./Hooks/MiniPlayer";
import { config } from "JS/Config";
import { RequireAuth } from "./Scenes/DownloadsOffline/RequireAuth";

export const RootOffline = () => {
    const { routeBuilder } = useRouting();
    const routeProvider = routeBuilder();
    const deviceAllowed = isDeviceAllowed();
    const { isZoomAllowed } = useGlobalMedia();
    const { resetGlobalMiniPlayer } = useMiniPlayer();

    useEffect(() => {
        setTimeout(() => resetGlobalMiniPlayer(), 1000);

        return () => resetGlobalMiniPlayer();
    }, []);

    const isLoggedIn = !!config.user.memberId;

    return (
        <React.Fragment>
            {!isZoomAllowed ? (
                <Helmet>
                    <meta charSet="utf-8" />
                    <meta
                        name="viewport"
                        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0, viewport-fit=cover"
                    />
                </Helmet>
            ) : (
                <Helmet>
                    <meta charSet="utf-8" />
                    <meta
                        name="viewport"
                        content="width=device-width, user-scalable=1, viewport-fit=cover"
                    />
                </Helmet>
            )}
            {!isLoggedIn && <RequireAuth />}
            {isLoggedIn && (
                <Router>
                    {deviceAllowed ? (
                        <>
                            <Routes>
                                <Route
                                    path={routeProvider.react.offline().index()}
                                    element={<DownloadMenu />}
                                />
                                <Route
                                    path={routeProvider.react
                                        .offline()
                                        .listing()}
                                    element={<DownloadsOffline />}
                                />
                                <Route
                                    path={routeProvider.react
                                        .offline()
                                        .playlist()
                                        .index()}
                                    element={<PlaylistListing />}
                                />
                                <Route
                                    path={routeProvider.react
                                        .offline()
                                        .playlist()
                                        .detail()}
                                    element={<PlaylistDetail />}
                                />
                                <Route
                                    path={routeProvider.react
                                        .offline()
                                        .playlist()
                                        .play()}
                                    element={<PlaylistPlayer />}
                                />
                                <Route
                                    path={routeProvider.react
                                        .offline()
                                        .documents()
                                        .index()}
                                    element={<OfflineDocuments />}
                                />
                                <Route
                                    path={routeProvider.react
                                        .offline()
                                        .documents()
                                        .detail()}
                                    element={<OfflineDocumentDetail />}
                                />
                                <Route
                                    path={routeProvider.react
                                        .offline()
                                        .courses()
                                        .index()}
                                    element={<OfflineCourses />}
                                />
                                <Route
                                    path={routeProvider.react
                                        .offline()
                                        .courses()
                                        .detail()}
                                    element={<OfflineCourseDetail />}
                                />
                                <Route
                                    path={routeProvider.react
                                        .offline()
                                        .courses()
                                        .mediaStepDetail()}
                                    element={<OfflineCourseStep />}
                                />
                                <Route
                                    path={routeProvider.react
                                        .offline()
                                        .downloaddetail()}
                                    element={<ContentDetailOffline />}
                                />
                                <Route
                                    path={routeProvider.react
                                        .offline()
                                        .bundle()
                                        .audios()}
                                    element={<BundleDetailOffline />}
                                />
                                <Route
                                    path={routeProvider.react
                                        .offline()
                                        .bundle()
                                        .play()}
                                    element={<BundlePlayerOffline />}
                                />
                                <Route
                                    path={routeProvider.react
                                        .offline()
                                        .attachedSku()}
                                    element={<AttachedSkuOffline />}
                                />
                                <Route
                                    path="*"
                                    element={
                                        <Navigate
                                            to={routeProvider.react
                                                .offline()
                                                .index()}
                                            replace
                                        />
                                    }
                                />
                            </Routes>
                        </>
                    ) : (
                        <Routes>
                            <Route
                                path={routeProvider.react.root()}
                                element={
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <Typography variant="h5">
                                            Not Available
                                        </Typography>
                                    </Box>
                                }
                            />
                        </Routes>
                    )}
                </Router>
            )}
        </React.Fragment>
    );
};
